import { 
  Avatar, 
  Container, 
  Float, 
  Heading, 
  Icon, 
  VStack, 
  Text, 
  Grid, 
  GridItem, 
  Flex 
} from "@chakra-ui/react"
import { Tooltip } from "../../../components/UI/tooltip"
import { LuBadgeCheck, LuBadge } from "react-icons/lu"
import { createFileRoute, notFound } from "@tanstack/react-router"
import AuthorError from "../../../components/Common/AuthorError"
import NotFound from "../../../components/Common/NotFound"
import PublicationPreview from "../../../components/Publications/PublicationPreview"
import { useQuery } from "@tanstack/react-query"
import { getAuthor } from "../../../api/authors"

export const Route = createFileRoute("/_layout/autor/$authorId")({
  component: PostComponent,
  errorComponent: (e) => {
    const status = (e as any)?.error.status
    if(status && status == 405)
      return <AuthorError/>
    throw notFound()
  },
  notFoundComponent: NotFound,
})

/* TODO:
* Get list of last images
*/


function PostComponent() {
  const { authorId } = Route.useParams()

  const { data: author, error } = useQuery({
      ...getAuthor({ authorId: authorId }),
  })

  if(error) throw error

  return (
    <Container py="20">
      <VStack gap="6">
        <Avatar.Root
          boxShadow="rgba(0, 0, 0, 0.24) 0px 3px 8px"
          css={{
            "--avatar-size": "sizes.48",
            "--avatar-font-size": "fontSizes.3xl",
          }}
          data-testid="avatar-image"
        >
          <Avatar.Fallback
            name={
              author?.lastname && author?.firstname
                ? `${author.lastname} ${author.firstname}`
                : author?.firstname || author?.lastname || author?.abbreviation || undefined
            }
          />
          <Avatar.Image src={author?.fk_media_profile_pic?.path.replace(/-(LG)\./, "-SM.")} />

          {author?.is_active ? (
            <Float
              offset="7"
              placement="top-end"
              boxSize="10"
              layerStyle="fill.solid"
              rounded="full"
              borderWidth="4px"
              borderColor="bg"
              backgroundColor="main"
              data-testid="active"
            >
              <Tooltip
                showArrow
                content="Aktiver Autor"
                openDelay={100}
                contentProps={{
                  css: { "--tooltip-bg": "#0087CA", color: "white" },
                }}
              >
                <Icon rounded="full" size="md" as={LuBadgeCheck} />
              </Tooltip>
            </Float>
          ) : (
            <Float
              offset="4"
              placement="top-end"
              boxSize="10"
              layerStyle="fill.solid"
              rounded="full"
              borderWidth="4px"
              borderColor="bg"
              backgroundColor="dim"
              data-testid="inactive"
            >
              <Tooltip
                showArrow
                content="Inaktiver Autor"
                openDelay={100}
                contentProps={{
                  css: { "--tooltip-bg": "#0087CA", color: "white" },
                }}
              >
                <Icon rounded="full" size="md" as={LuBadge} />
              </Tooltip>
            </Float>
          )}
        </Avatar.Root>

        <VStack>
          <Heading size="2xl" color="main">
            {author?.lastname && author?.firstname
              ? `${author.lastname} ${author.firstname}`
              : author?.firstname || author?.lastname}
            {author?.abbreviation ? ` (${author?.abbreviation})` : ""}
          </Heading>
          <Text w="60%">{author?.description}</Text>
        </VStack>

        {author?.latest_publications ? (
          <Flex direction="column">
            <Heading size="md" color="main" mt={10} mb={5}>Letzte Beiträge</Heading>
            <Grid
                templateColumns={{
                    base: "repeat(1, 1fr)",
                    lg: "repeat(2, 1fr)",
                    xl: "repeat(2, 1fr)",
                    "2xl": "repeat(4, 1fr)",
                }}
                gap="2em"
                justifyItems="center"
                justifyContent="center"
                data-testid="first-four"
            >
              {author?.latest_publications?.map((pub) => (
                <GridItem cursor="pointer" key={pub.id} w="full" h="full">
                  <PublicationPreview publication={pub} />
                </GridItem>
              ))}
            </Grid>
          </Flex>
        ) : (
            <Text>Dieser Autor hat noch keine Beiträge</Text>
        )}
      </VStack>
    </Container>
  )
}
